import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { deepCopy, toNumber, toAUD } from "../../components/Common";
import { Palette } from "../../AppConfig";
import BSL_Dialog from "../../components/BSL_Dialog";
import DeleteIcon from "@material-ui/icons/Delete";
import { IconButton } from "@material-ui/core";
import BSL_TextInput from "../../components/BSL_TextInput";
import BSL_CheckBox from "../../components/BSL_CheckBox";

const useStyles = makeStyles({
    root: {
        flex: 1,
        maxWidth: "90%",
        minWidth: "600px",
    },
    col_header: {
        backgroundColor: Palette.Control.FieldersDarkBlue,
        color: "white",
        fontSize: "12px",
        fontFamily: '"Univers45", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontWeight: "200",
        textAlign: "center",
        padding: "5px 0px",
    },
    row_header: {
        // backgroundColor: "red",
        display: "flex",
    },
    row_style: {
        padding: "0px 4px !important",
        display: "flex",
    },

    row_cell: {
        // backgroundColor: "red",
        textAlign: "center",
        display: "flex",
    },
    admin_drawer_root: {
        top: "0px",
        left: "0px",
        width: "90%",
        height: "-webkit-fill-available",
        display: "flex",
        overflow: "hidden",
        position: "fixed",
        textAlign: "left",
        borderLeft: "3px solid #0000001f",
        borderRadius: "0px",
        flexDirection: "column",
        backdropFilter: "blur(4px)",
        backgroundColor: "#edf0f3e8",
        paddingTop: "103px",
    },
    logo: {
        width: "100%",
        textAlign: "center",
        height: "100px",
        display: "flex",
        alignItems: "center",
        border: "2px dotted #8585b1",
        margin: "10px",
        justifyContent: "center",

        objectFit: "contain",
        "&:hover": {
            backgroundColor: Palette.Control.LightGrey,
        },
    },
    input: {
        display: "none",
    },
    import_logo: {
        position: "absolute",
        left: "0px",
        width: "96%",
        textAlign: "right",
        height: "111px",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-start",
        zIndex: 10,
    },
});

export default function QuotePageEditExtras(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { job, onClose, open } = props;
    const [extraItems, setExtraItems] = React.useState(
        job?.QuoteParameters?.PRICING_PARAMETERS?.ExtraItems ? job?.QuoteParameters?.PRICING_PARAMETERS?.ExtraItems : {}
    );
    const [showExtraItems, setShowExtraItems] = React.useState(
        job?.QuoteParameters?.PRICING_PARAMETERS?.ShowExtraItemsBreakDownOnQuote
            ? job?.QuoteParameters?.PRICING_PARAMETERS?.ShowExtraItemsBreakDownOnQuote
            : false
    );
    // const rows = useSelector(state => state.app.user_last_jobs_edited);

    const deleteItem = (key) => {
        let newExtraItems = deepCopy(extraItems);
        delete newExtraItems[key];
        setExtraItems(newExtraItems);
    };

    const updateItem = (key, param, value) => {
        let newExtraItems = deepCopy(extraItems);
        newExtraItems[key][param] = value;
        newExtraItems[key]["Subtotal"] = toNumber(newExtraItems[key]["Qty"]) * toNumber(newExtraItems[key]["UnitCost"]);
        setExtraItems(newExtraItems);
    };

    const addItem = (key) => {
        if (key === "") return;
        if (extraItems[key]) return;
        let newExtraItems = deepCopy(extraItems);
        newExtraItems[key] = {
            Name: key,
            Qty: 0,
            UnitCost: 0,
            Subtotal: 0,
            Note: "",
        };
        setExtraItems(newExtraItems);
    };

    let extra_item_rows = [];

    let input_style = { padding: "0px", margin: "1px" };

    let total = 0;

    for (let key in extraItems) {
        let extra_item = extraItems[key];
        total += extra_item.Subtotal;
        extra_item_rows.push(
            <div className={classes.row_style}>
                <div className={classes.row_header} style={{ flex: 7 }}>
                    <IconButton
                        aria-label="delete"
                        size="small"
                        onClick={() => {
                            deleteItem(key);
                        }}
                    >
                        <DeleteIcon fontSize="inherit" />
                    </IconButton>
                    <BSL_TextInput
                        value={extra_item.Name}
                        preValidate="alphaNumeric"
                        tight
                        style={input_style}
                        onBlur={(val) => updateItem(key, "Name", val)}
                    />
                </div>
                <div className={classes.row_cell} style={{ flex: 2 }}>
                    <BSL_TextInput
                        value={extra_item.Qty}
                        type="number"
                        tight
                        min={0}
                        max={200}
                        style={input_style}
                        onChange={(val) => updateItem(key, "Qty", val)}
                    />
                </div>
                <div className={classes.row_cell} style={{ flex: 3 }}>
                    {" "}
                    <BSL_TextInput
                        value={extra_item.UnitCost}
                        tight
                        min={0}
                        max={100000}
                        startAdornment="$"
                        style={input_style}
                        onChange={(val) => updateItem(key, "UnitCost", val)}
                        onBlur={(val) => updateItem(key, "UnitCost", val)}
                    />{" "}
                </div>
                <div className={classes.row_cell} style={{ flex: 3 }}>
                    {" "}
                    <BSL_TextInput
                        value={extra_item.Subtotal}
                        tight
                        min={0}
                        max={100000}
                        startAdornment="$"
                        disabled
                        style={input_style}
                        onBlur={(val) => updateItem(key, "Subtotal", val)}
                    />{" "}
                </div>
                <div className={classes.row_cell} style={{ flex: 10 }}>
                    {" "}
                    <BSL_TextInput
                        value={extra_item.Note}
                        tight
                        style={input_style}
                        onBlur={(val) => updateItem(key, "Note", val)}
                    />{" "}
                </div>
            </div>
        );
    }

    return (
        <BSL_Dialog
            title="Add Extra Items"
            open={props.open}
            onClose={onClose}
            button1Text="Save"
            button1Click={() => {
                props.updateJobState("QuoteParameters.PRICING_PARAMETERS", "ExtraItems", extraItems);
                props.updateJobState("QuoteParameters.PRICING_PARAMETERS", "ExtraCostsFixedPrice", total);
                props.updateJobState(
                    "QuoteParameters.PRICING_PARAMETERS",
                    "ShowExtraItemsBreakDownOnQuote",
                    showExtraItems
                );
                onClose(total);
            }}
            button2Text="Cancel"
            button2Click={() => {
                onClose();
            }}
            style={{ maxWidth: "initial" }}
            fullWidth={true}
            maxWidth={"md"}
        >
            <div style={{ padding: "10px", minWidth: "600px", display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex" }}>
                    <div
                        className={classes.col_header}
                        style={{
                            borderTopLeftRadius: "4px",
                            flex: 7,
                        }}
                    >
                        {" "}
                        Name{" "}
                    </div>
                    <div className={classes.col_header} style={{ flex: 2 }}>
                        {" "}
                        Qty{" "}
                    </div>
                    <div className={classes.col_header} style={{ flex: 3 }}>
                        {" "}
                        $/Unit{" "}
                    </div>
                    <div className={classes.col_header} style={{ flex: 3 }}>
                        {" "}
                        Subtotal{" "}
                    </div>
                    <div
                        className={classes.col_header}
                        style={{
                            borderTopRightRadius: "4px",
                            flex: 10,
                        }}
                    >
                        {" "}
                        Notes{" "}
                    </div>
                </div>
                {extra_item_rows}

                <div style={{ display: "flex" }}>
                    <div
                        className={classes.row_header}
                        style={{
                            marginLeft: "28px",
                            flex: 7,
                        }}
                    >
                        <BSL_TextInput
                            placeholder="new item"
                            value={""}
                            tight
                            style={input_style}
                            onBlur={(val) => addItem(val)}
                        />
                    </div>
                    <div
                        style={{
                            flex: 18,
                        }}
                    >
                        {" "}
                    </div>
                </div>

                <div style={{ display: "flex" }}>
                    <div
                        className={classes.row_header}
                        style={{
                            flex: 7,
                        }}
                    >
                        {" "}
                    </div>
                    <div style={{ flex: 2 }}> </div>
                    <div
                        style={{
                            flex: 3,
                            font: "18px 'Univers45', sans-serif",
                            fontWeight: "800",
                        }}
                    >
                        TOTAL
                    </div>
                    <div
                        style={{
                            flex: 3,
                            font: "18px 'Univers45', sans-serif",
                            fontWeight: "800",
                            color: Palette.FieldersBlue,
                            marginLeft: "5px",
                        }}
                    >
                        {toAUD(total)}
                    </div>
                    <div
                        style={{
                            flex: 10,
                        }}
                    >
                        <BSL_CheckBox
                            tight
                            checked={showExtraItems}
                            label="Show breakdown on Quote"
                            onChange={() => setShowExtraItems(!showExtraItems)}
                            style={{
                                marginTop: "-12px",
                            }}
                        />
                    </div>
                </div>
            </div>
        </BSL_Dialog>
    );
}
